/**
 * The board's screen-density bucket — how many screen pixels one native
 * (spine-unit) pixel covers, snapped to 1, 1.5 or 2. Above 1 only on screens
 * where the board is drawn larger than native (ULTRA_WIDE).
 *
 * Set by SpineTextureExtractor.setCompositeDensity (which the base game view
 * feeds the on-screen cell); read by anything that rasterises at native size
 * and must stay sharp when magnified — the composites and the label cache.
 * A module of its own so neither has to import the other.
 */
let density = 1;

export const getScreenDensity = () => density;

export const setScreenDensity = (value) => {
  density = value > 0 ? value : 1;
};
